import BaseModelAPI from '../BaseModelAPI';

export default class StockAdjustmentTypeList extends BaseModelAPI {

	static entity = 'stockadjustmenttypelist'
	static entityName = 'stockadjustmenttype';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
